module.exports = __webpack_public_path__ + "img/32.e93a2e4f.jpeg";